import { useFormContext as C, Controller as g } from "react-hook-form";
import { Check as N } from "@styled-icons/boxicons-regular";
import d from "classnames";
import k from "next/dynamic";
import * as u from "@radix-ui/react-checkbox";
import { option as E, checkbox as I, checkboxSelected as q, indicator as y } from "./MultiSelectionElement.css.js";
import { formInputElement as A, inputLabel as M, asteriskContainer as _, inputErrorMessage as F } from "./FormInputElement.css.js";
import { jsxs as i, jsx as e } from "react/jsx-runtime";
const S = k(() => import("@hookform/error-message").then((r) => r.ErrorMessage), {
  ssr: !1
});
function z({
  element: r,
  children: m,
  className: h,
  attributes: p
}) {
  var c;
  const n = `input-${r.id}`, {
    control: b,
    formState: {
      errors: t
    }
  } = C() || {};
  return /* @__PURE__ */ i("div", {
    ...r.customAttributes,
    className: d(h, A, (c = r.customAttributes) == null ? void 0 : c.className),
    ...p,
    children: [!r.is_label_hidden && /* @__PURE__ */ i("label", {
      htmlFor: n,
      className: M,
      contentEditable: !1,
      children: [r.label, r.required && /* @__PURE__ */ e("span", {
        style: {
          color: "var(--danger)"
        },
        children: "\xA0*"
      })]
    }), (r.options || []).map((a, f) => /* @__PURE__ */ e(g, {
      name: r.name,
      control: b,
      defaultValue: [],
      rules: {
        required: r.required
      },
      render: ({
        field: s
      }) => /* @__PURE__ */ i(u.Root, {
        className: E,
        onCheckedChange: (v) => {
          if (r.disabled)
            return;
          let o = -1;
          const l = [...s.value];
          o = l.findIndex((x) => x === a.value), o !== -1 && !v ? (l.splice(o, 1), s.onChange(l)) : s.onChange([...l, a.value]);
        },
        ...s,
        children: [/* @__PURE__ */ e("div", {
          className: d(I, {
            [q]: s.value.includes(a.value)
          }),
          children: /* @__PURE__ */ e(u.Indicator, {
            asChild: !0,
            children: /* @__PURE__ */ e(N, {
              className: y
            })
          })
        }), /* @__PURE__ */ i("label", {
          htmlFor: `${n}-${a.value}`,
          style: {
            display: "flex",
            flex: 2,
            textAlign: "start",
            wordBreak: "break-all"
          },
          contentEditable: !1,
          children: [r.required && f === 0 && r.is_label_hidden && /* @__PURE__ */ e("div", {
            className: _,
            children: /* @__PURE__ */ e("span", {
              children: "*"
            })
          }), a.label]
        })]
      })
    }, a.value)), t && /* @__PURE__ */ e(S, {
      errors: t,
      name: r.name,
      render: (a) => /* @__PURE__ */ e("div", {
        className: F,
        children: a.message
      })
    }), m]
  });
}
export {
  z as MultiSelectionElement
};
